import { render } from "./messageItem.vue?vue&type=template&id=e7d880b0"
import script from "./messageItem.vue?vue&type=script&lang=js"
export * from "./messageItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__